module.exports = __webpack_public_path__ + "media/images/emblems/Biberist-blason-3500df62e905422853c2124849a1a17b.png";